module.exports = __webpack_public_path__ + "static/media/configurator.a35d1313.mp4";